// extracted by mini-css-extract-plugin
export default {"info":"hTfFzmMZ","avatar":"OEk1_rtJ","titleRow":"Qs_IvOqy","title":"nJhhRtn1","nftIndicator":"XS_yoO9u","icon":"RIuREHy9","address":"eL4ssW06","balance":"cADp_3Dn"};